import { render, staticRenderFns } from "./EmployeePropertyWorkShift.vue?vue&type=template&id=73a08938&"
import script from "./EmployeePropertyWorkShift.vue?vue&type=script&lang=js&"
export * from "./EmployeePropertyWorkShift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSelect,QBtn,QTooltip,QDialog} from 'quasar'
component.options.components = Object.assign({QSelect,QBtn,QTooltip,QDialog}, component.options.components || {})
